import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { SetField } from '../components/Table/fields/SetField';
import { address } from './address';
import { contact } from './contact';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { SPTextField } from '../components/Table/fields/SPTextField';
export const stripperProvider: SchemaWithClient<any> = {
  name: 'Stripper Providers',
  pluralName: 'Stripper Providers',
  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      fieldType: 'text',
      required: true,
    },
    description: {
      name: 'Description',
      fieldRenderer: TextField,
      fieldType: 'textarea',
    },
    service_provider_type: {
      name: 'Type',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceProviderType),
      url: enumItems.serviceProviderType.client.getAllPath,
      tempSchema: enumItems.serviceProviderType,
      switchboard: true,
    },
    website: {
      name: 'Website',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    venue_address: {
      name: 'Venue Addresses',
      fieldRenderer: SetField.tableAdapter(address),
      url: address.client.getAllPath,
      tempSchema: address,
      switchboard: true,
    },
    legal_entity: {
      name: 'Legal Entity',
      fieldRenderer: SelectField.tableAdapter(enumItems.paymentMethod),
      switchboard: true,
      url: enumItems.paymentMethod.client.getAllPath,
      tempSchema: enumItems.paymentMethod,
    },
    legal_name: {
      name: 'Legal Name',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    tax_number: {
      name: 'Tax Number',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    bank_account_number: {
      name: 'Bank Account Number',
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    /*  headquarters_address: {
      name: 'Headquarters Address',
      fieldRenderer: SelectField.tableAdapter(address),
      url: address.client.getAllPath,
      tempSchema: address,
      switchboard: true,
    },*/
    company_seat: {
      name: 'Company seat',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    contacts: {
      name: 'Contacts',
      fieldRenderer: SetField.tableAdapter(contact),
      url: contact.client.getAllPath,
      tempSchema: contact,
      multiSwitchboard: true,
    },
    /* finance_contacts: {
      name: 'Finance Contact',
      fieldRenderer: SetField.tableAdapter(contact),
      url: contact.client.getAllPath,
      tempSchema: contact,
      multiSwitchboard: true,
    },*/
    paid_by: {
      name: 'Paid By',
      fieldRenderer: SelectField.tableAdapter(enumItems.paidBy),
      url: enumItems.paidBy.client.getAllPath,
      tempSchema: enumItems.paidBy,
      switchboard: true,
    },
    payment_method: {
      name: 'Payment Method',
      fieldRenderer: SelectField.tableAdapter(enumItems.paymentMethod),
      url: enumItems.paymentMethod.client.getAllPath,
      tempSchema: enumItems.paymentMethod,
      switchboard: true,
    },
    payment_due: {
      name: 'Payment Due',
      fieldRenderer: SelectField.tableAdapter(enumItems.paymentDue),
      url: enumItems.paymentDue.client.getAllPath,
      tempSchema: enumItems.paymentDue,
      switchboard: true,
    },
    active: {
      name: 'Active',
      fieldRenderer: BooleanField,
      fieldType: 'boolean',
    },
    notes: {
      name: 'Notes',
      fieldRenderer: TextField,
      fieldType: 'textarea',
    },

    /*partner_prices: {
      name: 'Partner Prices',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
      tab_name: 'accommodation',
    },
    partner_fix_price: {
      name: 'Partner Fix Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      tab_name: 'accommodation',
    },
    partner_fix_price_currency: {
      name: 'Partner Fix Price Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      multiSwitchboard: true,
      tab_name: 'accommodation',
    },
    partner_discount: {
      name: 'Discount',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      tab_name: 'accommodation',
    },
    partner_price_description: {
      name: 'Partner Price Description',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
      tab_name: 'accommodation',
    },
    breakfast_price: {
      name: 'Breakfast Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      tab_name: 'accommodation',
    },
    breakfast_price_currency: {
      name: 'Breakfast Price Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.currency),
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      multiSwitchboard: true,
      tab_name: 'accommodation',
    },*/

    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },

  client: new Client(`/stripper-providers`),
};
